import { ReturnShortCallReadable, ReturnTaskReadable } from '@crm/api'
import * as React from 'react'

interface LogsPanelContextState {
  isOpenSendMail: boolean
  toggleSendMail: () => void

  isOpenCreateNote: boolean
  toggleCreateNote: () => void

  isOpenCreateMeeting: boolean
  toggleCreateMeeting: () => void

  callItem?: ReturnShortCallReadable
  openPlayer: (call: ReturnShortCallReadable) => void
  closePlayer: () => void
  openCompleteTask: (task: ReturnTaskReadable) => void
}

const defaultContextValue: LogsPanelContextState = {
  isOpenSendMail: false,
  toggleSendMail: () => null,
  isOpenCreateNote: false,
  toggleCreateNote: () => null,
  isOpenCreateMeeting: false,
  toggleCreateMeeting: () => null,
  callItem: undefined,
  openPlayer: () => null,
  closePlayer: () => null,
  openCompleteTask: () => null
}

export default React.createContext<LogsPanelContextState>(defaultContextValue)
